// ---------------------------------------------------------------
// Copyright (c) Aspen Publishing. All rights reserved.
// ---------------------------------------------------------------

const CartRemoveTrigger = class extends HTMLElement {
  connectedCallback() {
    this.template = this.querySelector('template').content;
    this.setAttribute('tabindex', '0');
    this.setAttribute('role', 'button');
    this.addEventListener('click', this.openPopup.bind(this));
    this.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.openPopup();
    }
  }

  async openPopup() {
    const url = `${this.dataset.url}?section_id=popup-confirm-remove`;
    document.body.classList.add('event-none');
    let result = await fetch(url);
    result = await result.text();
    result = result.split('<!-- split -->')[1].replace('append-auto', '');
    document.body.insertAdjacentHTML('beforeend', result);
    let popup = document.querySelector('#popup-confirm-remove');
    popup.style.display = 'flex';

    let popupBtnRemove = document.body.querySelector('#popup-btn-remove-line-cart');

    popupBtnRemove.innerHTML = this.template.querySelector('.popup-cart-remove-button-wrapper').innerHTML;
    popupBtnRemove.addEventListener('click', this.initEvents.bind(this));

    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);

    document.body.classList.remove('event-none');

    popup._triggerElement = this;
    popup.open();

    setTimeout(() => {
      const keepBtn = popup.querySelector('.btn-primary.jsClose');

      if (keepBtn) {
        keepBtn.focus();
      }
    }, 100);
  }

  initEvents() {
    let popupBtnRemove = document.querySelector('.popup-cart-remove-button');
    let removeTarget = document.querySelector(`.${popupBtnRemove.dataset.class} a`);

    removeTarget.click();
  }
};

if (!customElements.get('cart-remove-trigger')) {
  customElements.define('cart-remove-trigger', CartRemoveTrigger);
}
